import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "app" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderV = _resolveComponent("HeaderV")!
  const _component_FormulairePaiement = _resolveComponent("FormulairePaiement")!
  const _component_FooterV = _resolveComponent("FooterV")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", null, [
      _createVNode(_component_HeaderV)
    ]),
    _createElementVNode("main", null, [
      _createVNode(_component_FormulairePaiement)
    ]),
    _createElementVNode("footer", null, [
      _createVNode(_component_FooterV)
    ])
  ]))
}